import { ApiResult } from '@src/api/apiClient/apiResult';
import { axiosClient } from '@src/api/apiClient/axiosClient';

type ResetPasswordPostRequest = {
  email: string;
};
type ResetPasswordPostResponse = {
  message: string;
};
type ResetPasswordPostErrorResponse = {
  email?: string[];
  message?: string[];
};
type ResetPasswordTokenResponse = {
  email: string;
};
type ResetPasswordUpdateRequest = {
  token: string | undefined;
  email: string;
  new_password: string;
  new_password_confirmation: string;
};
type ResetPasswordUpdateResponse = {
  message: string;
};
type ResetPasswordUpdateErrorResponse = {
  email?: string[];
  new_password?: string[];
  new_password_confirmation?: string[];
  message?: string[];
};

export const companyResetPasswordApiClient = {
  reset: async (
    params: ResetPasswordPostRequest,
  ): Promise<ApiResult<ResetPasswordPostResponse, ResetPasswordPostErrorResponse>> => {
    return await axiosClient.post('/company/auth/reset-password', params);
  },
  token: async (token: string): Promise<ApiResult<ResetPasswordTokenResponse>> => {
    return await axiosClient.get(`/company/auth/reset-password/${token}`);
  },
  update: async (
    params: ResetPasswordUpdateRequest,
  ): Promise<ApiResult<ResetPasswordUpdateResponse, ResetPasswordUpdateErrorResponse>> => {
    return await axiosClient.put('/company/auth/reset-password', params);
  },
};
